// listener.js
import { messaging } from '../lib/firebase';
import { onMessage } from 'firebase/messaging';

onMessage(messaging, (payload) => {
  const { title, body } = payload.data;
  navigator.serviceWorker.ready.then(registration => {
    registration.showNotification(title, {
      body,
      icon: '/logo192.png',
      data: { targetView: payload.data?.targetView || 'risk' }
    });
  });
});
